import React from 'react';
import PropTypes from 'prop-types';
import DeleteButton from '../../../v2/buttons/DeleteButton';

export default function ReferenceNumberTable({
  referenceNumbers,
  label,
  onRemove,
}) {
  function handleRemove(referenceNumber) {
    return function () {
      onRemove(referenceNumber);
    };
  }

  return (
    <div className="overflow-x-auto">
      <table className="default-table">
        <thead>
          <tr>
            <th>{label}</th>
            <th>&nbsp;</th>
          </tr>
        </thead>
        <tbody>
          {referenceNumbers.map((referenceNumber, i) => (
            <tr key={i}>
              <td>{referenceNumber}</td>
              <td>
                <DeleteButton onClick={handleRemove(referenceNumber)} />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

ReferenceNumberTable.propTypes = {
  referenceNumbers: PropTypes.arrayOf(PropTypes.string),
  onRemove: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
};
